import { render } from "./late-comers.vue?vue&type=template&id=112d4921"
import script from "./late-comers.vue?vue&type=script&lang=js"
export * from "./late-comers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__